export default __webpack_public_path__ + "static/admin-close-f1e71b4b.svg";